import React, { useState } from 'react'
import { withTranslation } from 'react-i18next'
import PayoutStats from './components/PayoutStats'
import PayoutFilterBar from './components/PayoutFilterBar'
import PayoutDetailCard from './components/PayoutDetailCard'
import PrizeSecurityAccountCard from './components/PrizeSecurityAccountCard'
import WinnersByStatusCard from './components/WinnersByStatusCard'
import TopPrizeTypeCard from './components/TopPrizeTypeCard'
import RecentPayoutTransactionsCard from './components/RecentPayoutTransactionsCard'
import WinnersInformationSection from './components/WinnersInformationSection'
import WinnerDetail from './components/WinnerDetail'
import ProofOfPayoutModal from './components/ProofOfPayoutModal'

// No payout endpoints exist on the backend yet — this page ships as a static
// scaffold (matching the Billing page's convention) with empty/zero defaults,
// ready to be wired to real data once the API contract is confirmed.
export default withTranslation()(function Payout({ t }) {
  const [year, setYear] = useState('')
  const [account, setAccount] = useState('')
  const [type, setType] = useState('')
  const [status, setStatus] = useState('')
  const [viewingWinner, setViewingWinner] = useState(null)
  const [viewingImage, setViewingImage] = useState(false)

  const currentPayout = null
  const transactions = []
  const winners = []

  if (viewingWinner) {
    return (
      <>
        <WinnerDetail
          winner={viewingWinner}
          onBack={() => setViewingWinner(null)}
          onViewImage={() => setViewingImage(true)}
        />

        {viewingImage && <ProofOfPayoutModal imageUrl={viewingWinner.proof?.imageUrl} onClose={() => setViewingImage(false)} />}
      </>
    )
  }

  return (
    <section className="w-full max-w-6xl mx-auto pb-10">
      <div className="flex items-center justify-between gap-4 mb-5">
        <h1 className="text-2xl font-semibold text-dark-blue">{t('payout.title')}</h1>
      </div>

      <PayoutStats />

      <PayoutFilterBar
        year={year}
        onChangeYear={setYear}
        account={account}
        onChangeAccount={setAccount}
        type={type}
        onChangeType={setType}
        status={status}
        onChangeStatus={setStatus}
        onExport={() => {}}
      />

      <div className="grid md:grid-cols-2 gap-5 mb-5">
        <PayoutDetailCard payout={currentPayout} onViewAll={() => {}} />
        <PrizeSecurityAccountCard />
      </div>

      <div className="grid md:grid-cols-2 gap-5 mb-5">
        <WinnersByStatusCard />
        <TopPrizeTypeCard />
      </div>

      <div className="mb-5">
        <RecentPayoutTransactionsCard
          rows={transactions}
          onViewAll={() => {}}
          onRowClick={(row) => row.winner && setViewingWinner(row.winner)}
        />
      </div>

      <WinnersInformationSection
        winners={winners}
        onRowClick={setViewingWinner}
        onExport={() => {}}
      />
    </section>
  )
})
